export default __webpack_public_path__ + "static/media/logo10_3_161442.46b198d2.jpeg";